import ThirdPartyJobPaymentsAdmin from "./ThirdPartyJobPaymentsAdmin";

export default class PendingApprovalTpJobTab extends ThirdPartyJobPaymentsAdmin {
  getType() {
    return 'pending_approval';
  }
}
